import React from 'react'
import portadaLogin from '../../../assets/img/login-portada.png'

function BannerLogin() {
    return (
        <div className="login-fondo">
            <img
                src={portadaLogin}
                height={"100%"} style={{ width: "100%", objectFit: "cover", height: "100%" }}
            />
        </div>
    )
}

export default BannerLogin